export function focusInputElementOnError({ id, errorClass }: { id: string; errorClass: string }): void {
    const cont = document.getElementById(id);
    cont?.classList.add(errorClass);
    const inputElementButtons = cont?.querySelectorAll<HTMLButtonElement>('button');
    // Fokuser første periode-input som ikke er fylt ut
    let allFilledOut = true;
    for (let i = 0; i < (inputElementButtons?.length ?? 0); i++) {
        const inputButton = inputElementButtons?.[i];
        if (!inputButton?.children[0].innerHTML) {
            inputButton?.focus();
            allFilledOut = false;
            return;
        }
    }
    // Fokuser første første periode-input dersom alle er fylt ut
    if (allFilledOut) inputElementButtons?.[0].focus();
}
